import { createAction, handleActions } from 'redux-actions';

// ACTION TYPES
const ATUALIZAR_STORE = `${process.env.PUBLIC_URL}/SERVICOS/ATUALIZAR_STORE`;
const SERVICOS_CONSULTAR_POR_ID = `${
	process.env.PUBLIC_URL
}/SERVICOS/CONSULTAR`;
const SERVICOS_CONSULTAR_POR_FILTRO = `${
	process.env.PUBLIC_URL
}/SERVICOS/CONSULTAR_POR`;
const SERVICOS_LIMPAR = `${process.env.PUBLIC_URL}/SERVICOS/LIMPAR`;
const SERVICOS_REMOVER = `${process.env.PUBLIC_URL}/SERVICOS/REMOVER`;
const SERVICOS_SALVAR = `${process.env.PUBLIC_URL}/SERVICOS/SALVAR`;

export const types = {
	ATUALIZAR_STORE,
	SERVICOS_CONSULTAR_POR_ID,
	SERVICOS_CONSULTAR_POR_FILTRO,
	SERVICOS_LIMPAR,
	SERVICOS_REMOVER,
	SERVICOS_SALVAR
};

// ACTIONS
const atualizarStore = createAction(ATUALIZAR_STORE);
const consultarPorCodigo = createAction(SERVICOS_CONSULTAR_POR_ID);
const consultarPorFiltro = createAction(SERVICOS_CONSULTAR_POR_FILTRO);
const limpar = createAction(SERVICOS_LIMPAR);
const remover = createAction(SERVICOS_REMOVER);
const salvar = createAction(SERVICOS_SALVAR);

export const actions = {
	atualizarStore,
	consultarPorCodigo,
	consultarPorFiltro,
	limpar,
	remover,
	salvar
};

// INITIAL STATE
const initialState = {};

// REDUCERS
const reducer = handleActions(
	{
		[ATUALIZAR_STORE]: (state, action) => {
			return { ...state, ...action.payload };
		}
	},
	initialState
);

export default reducer;

// SELECTORS
const getServicos = state => {
	return state.servicos.lista || {};
};

const getListaServicos = state => {
	return getServicos(state).list || [];
};

const getCurrentPage = state => {
	return getServicos(state).page || 0;
};

const getTotalServicos = state => {
	return getServicos(state).total || 0;
};

const getTotalPaginas = state => {
	return getServicos(state).pages || 0;
};

const getServico = state => {
	return state.servicos.servico || {};
};

export const selectors = {
	getListaServicos,
	getCurrentPage,
	getTotalServicos,
	getTotalPaginas,
	getServico
};
